<template>
    <div style="text-align: center">
        <template>
            <div class="mt-4">
                <p v-if="fileHasErrors">The uploaded file failed validation and could not be processed. Download file to see errors.</p>
            </div>
            <div class="mt-4">
                <button v-if="fileHasErrors" class="btn btn-default" @click="downloadErrors">Download Errors File</button>
            </div>
            <div class="mt-4">
                <button v-if="fileExists" class="btn btn-default" @click="download">Download Enrollment File</button>
                <p v-else>No file was uploaded via action item</p>
            </div>
            <div class="p-1">
                <label class="btn btn-success btn-file">
                    Upload enrollment file <input type="file" ref="uploader" style="display: none;" @change="fileSelected" />
                </label>
            </div>
            <div v-if="processing">
                Processing.....
            </div>
        </template>
    </div>
</template>

<script>
import { toastService } from '../../framework.js';
import {uploadEnrollmentsService} from './upload-enrollments-service.js'
export default {
    props: ["item"],
    data () {
        return {
            fileExists: false,
            fileHasErrors: false,
            processing: false,
        }
    },
    created (){
        this.load();
    }, 
    methods: {
        ...amfx.map("actionItems", "changeStatus,validateCanChangeStatus"),
        async load() {
            this.fileExists = await uploadEnrollmentsService.checkIfFileExists(this.item.employerId,this.item.actionItemId);

            if(this.fileExists == true){
                this.fileHasErrors = await uploadEnrollmentsService.checkIfFileHadErrors(this.item.employerId,this.item.actionItemId);
            }
        },
        async download() {               
            this.busy = true;
            await romeApi.download(`employer/${this.item.employerId}/enrollment/download/latest/${this.item.actionItemId}`);           
            this.busy = false;     
        },
        async downloadErrors() {
            await romeApi.download(`employer/${this.item.employerId}/enrollment/errors/download/${this.item.actionItemId}`);
        },
       async fileSelected() {
            this.busy = true;
            
            var success = await uploadEnrollmentsService.onSpreadsheetSelect(this.$refs.uploader.files[0], this.item.employerId, this.item.actionItemId);
            
            this.$refs.uploader.value = null; 

            if(success === true) {
                await uploadEnrollmentsService.validateActionItem(this.item.employerId, this.item.actionItemId);

            } else {
                this.$refs.uploader[0].value = null; 
            } 
            this.busy = false;
        },
    }
}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/action-items/types/ReviewSpreadsheetEnrollments.vue